class firm {
    constructor(
      id,
      name,
      order

      ) {
      this.id = id;
      this.name = name;
      this.order = order;
    }
    static fromJson({
        operId,
        nombre,
        orden
    }) {
      return new firm(
        operId,
        nombre,
        orden
      );
    }
  }
  export default firm;
  